var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "feature",
      class:
        ((_obj = { disabled: _vm.disabled }), (_obj[_vm.type] = true), _obj),
      on: {
        click: function (e) {
          return _vm.toggleSwitch(e)
        },
      },
    },
    [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          { staticClass: "icon" },
          [_c(_vm.icon, { tag: "component" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "texts" },
          [
            _c("div", { staticClass: "feature-title title-color" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feature-description" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.description) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "right",
          on: {
            click: function (e) {
              return e.stopPropagation()
            },
          },
        },
        [
          _vm.type === "switch"
            ? _c("a-switch", {
                staticClass: "md-warning ml-3",
                attrs: {
                  name: "writing",
                  required: _vm.required,
                  "checked-children": "✔",
                  "un-checked-children": "✖",
                  disabled: _vm.disabled,
                  checked: _vm.clone,
                },
                model: {
                  value: _vm.clone,
                  callback: function ($$v) {
                    _vm.clone = $$v
                  },
                  expression: "clone",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "select"
            ? _c(
                "a-select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.required ? "required" : "",
                      expression: "required ? 'required' : ''",
                    },
                  ],
                  ref: "select",
                  staticStyle: { width: "202px" },
                  attrs: { autocomplete: "off" },
                  model: {
                    value: _vm.clone,
                    callback: function ($$v) {
                      _vm.clone = $$v
                    },
                    expression: "clone",
                  },
                },
                [
                  _vm.showNullSelectOption
                    ? _c("a-select-option", { attrs: { value: undefined } }, [
                        _vm._v(
                          _vm._s(_vm.defaultSelectOptionPlaceholder) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.options, function (option, index) {
                    return _c(
                      "a-select-option",
                      { key: index, attrs: { value: option.id } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option.label) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "number"
            ? _c(
                "div",
                { staticClass: "number-wrapper" },
                [
                  _c("a-button", {
                    attrs: {
                      type: "dashed",
                      shape: "circle",
                      icon: "minus",
                      disabled: _vm.clone <= _vm.min,
                    },
                    on: { click: _vm.decreaseValue },
                  }),
                  _vm._v(" "),
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.getNumericRequireText(),
                        expression: "getNumericRequireText()",
                      },
                    ],
                    staticClass: "text-align-center",
                    attrs: {
                      max: _vm.max,
                      min: _vm.min,
                      step: _vm.step,
                      autocomplete: "off",
                      placeholder: _vm.numberPlaceHolder,
                      trim: "",
                      type: "number",
                    },
                    model: {
                      value: _vm.clone,
                      callback: function ($$v) {
                        _vm.clone = $$v
                      },
                      expression: "clone",
                    },
                  }),
                  _vm._v(" "),
                  _c("a-button", {
                    attrs: {
                      type: "dashed",
                      shape: "circle",
                      icon: "plus",
                      disabled: _vm.clone >= _vm.max,
                    },
                    on: { click: _vm.increaseValue },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }